export default __webpack_public_path__ + "static/carrot-7c891db462ed58a87281dd86a3de05cb.webp";